export enum AnalyticsEventNameEnum {
  BOOKMARK = "Bookmark",
  DIGITAL_ADS = "Digital Ads",
  SCREEN_VIEW = "Screen View",
  SCREEN_LEAVE = "Screen Leave",
  SEARCH = "Search",
  FILTER_CLICKED = "Filter Clicked",
  ERROR = "Error",
  CLICK = "Click"
}

export enum AnalyticsScreenNameEnum {
  AGENDA_LISTING = "Agenda Listing",
  SPEAKER_LISTING = "Speaker Listing",
  EXHIBITOR_LISTING = "Exhibitor Listing",
  SPONSOR_LISTING = "Sponsor Listing",
  ADD_TO_SCHEDULE_LISTING = "Add to Schedule Listing",
  ATTENDEE_LISTING = "Attendee Listing",
  DASHBOARD = "Dashboard",
  PROFILE = "Profile",
  CATEGORY_KEYWORD_SPONSOR = "Category & Keyword Sponsor",
  ACCESS_AND_LEAD_MANAGEMENT = "Access & Lead Management",
  REQUEST = "Selection Request",
  OPT_IN = "Selection OptIn",
  REQUEST_AND_OPT_IN = "Selection Request and OptIn",
  ORG_ADMIN_SELECTION_REQUEST = "Organization Admin Participants List Selection Request",
  ORG_ADMIN_SELECTION_OPT_IN = "Organization Admin Participants List Selection OptIn",
  ORG_ADMIN_SELECTION_REQUEST_AND_OPT_IN = "Organization Admin Participants List Selection Request and OptIn",
  SELECTION_PRIMARY_FILTER = "Selection Primary Filter",
  SELECTION_SECONDARY_FILTER = "Selection Secondary Filter",
  REGISTRATION = "Registration",
  PAYMENT = "Payment",
  ALL_CONTACT_LIST = "All Contact Listing",
  COMPLETE_PROFILE = "Complete Profile",
  COMPLETE_PROFILE_ACTIVITY_LIST = "Complete Profile Activity List",
  AVAILABILITY = "Availability",
  SELECTION = "Selection",
  SELECTION_ACTIVITIES = "Selection Activities",
  PARTICIPANT_SCHEDULE = "Participant Schedule",
  MY_INFO = "My Info",
  PURCHASE_TICKET = "Purchase Ticket",
  RESEND_TICKET = "Resend Ticket",
  MANAGE_ORGANIZATION_ADMIN = "Manage Organization Admin",
  MANAGE_BULK_TICKET = "Manage Bulk Tickets",
  PURCHASE_HISTORY_LIST = "Purchase History List",
  UPGRADE_TICKET = "Upgrade Ticket",
  TRANSFER_TICKET = "Transfer Ticket",
  CANCEL_TICKET_TRANSFER = "Cancel Ticket Transfer",
  MY_ACCESS_LIST = "My Access List",
  POST_ON_SOCIAL_MEDIA = "Post on Social Media",
  ADDITIONAL_CHARGE = "Additional Charge",
  FAQ = "FAQ",
  HIDE_PARTICIPANT_DETAILS = "Hide Participant Details",
  CUSTOM_LINKS = "Custom Links",
  DISPLAY_PROFILE = "Display Profile",
  ACCEPT_REJECT_MEETING_LISTING = "Accept-Reject Meetings Listing",
  ASSIGN_MEETING_REP_MEETING_LISTING = "Assign Meeting Reps Meetings Listing",
  SCHEDULE_LISTING = "Schedule Listing",
  SCHEDULE_DETAILS = "Schedule Details",
  MEETING_COLLEAGUE_LISTING = "Meeting Colleague Listing",
  MEETING_NOTE = "Meeting Note",
  ORGANIZATION_SCHEDULE_LISTING = "Organization Schedule Listing",
  SUBMIT_FEEDBACK = "Submit Feedback",
  REIMBURSEMENT_DETAILS = "Reimbursement Details",
  EVENT_SUMMARY_REPORT = "Event Summary Report",
  PURCHASE_HOSTED_MEETINGS = "Purchase Hosted Meetings",
  MANAGE_PARTICIPANTS = "Manage Participants",
  TIMELINE = "Timeline",
  MEETING_SUMMARY_REPORT = "Meeting Summary Report",
  MY_CONTACT_REPORT = "My Contact Report",
  REIMBURSEMENT_OPT_IN = "Reimbursement Opt In",
  REIMBURSEMENT_OPT_OUT = "Reimbursement Opt Out",
  MY_ACTIONS = "My Actions",
  PURCHASE_INVOICE = "Purchase Invoice",
  DISPLAY_NOTE = "Display Note",
  ORG_ADMIN_PARTICIPANT_LIST_COMPLETE_PROFILE = "Organization Admin Participants List Complete Profile",
  ORG_ADMIN_PARTICIPANT_LIST_AGENDA = "Organization Admin Participants List Agenda",
  ORG_ADMIN_PARTICIPANT_LIST_FEEDBACK = "Organization Admin Participants List Feedback",
  ACTIVITY_SHORTLIST_PARTICIPANTS = "Activity Shortlist Participants",
  ACCEPT_REJECT_ACTIVITIES_LISTING = "Accept-Reject Activities Listing",
  MANAGE_ACTIVITY_LISTING = "Manage Activity Listing",
  MANAGE_ACTIVITY_PARTICIPANTS = "Manage Activity Participants",
  POWERED_BY_PERSONATECH = "Powered By Personatech",
  CREATE_ORG_ADMIN = "Create Organization Admin",
  ASSIGN_ORG_ADMIN = "Assign Organization Admin"
}

export enum AnalyticsActionNameEnum {
  VIEW = "View",
  CLICK = "Click",
  CLOSE = "Close",
  EMAIL = "Email",
  DOWNLOAD = "Download",
  SHARE_ON_LINKEDIN = "Share on Linkedin",
  SHARE_ON_TWITTER = "Share on Twitter",
  ADD = "Add"
}

export enum AnalyticsContextEntityTypeEnum {
  EVENT_AGENDA = "Event Agenda",
  AGENDA_MEMBERS = "Agenda Members",
  EVENT_ORGANIZATION = "Event Organization",
  EVENT_PARTICIPANT = "Event Participant",
  PROGRAM_PARTICIPANT = "Program Participant",
  REGISTRATION_ORGANIZATION = "Registration Organization",
  REGISTRATION_PARTICIPANT = "Registration Participant",
  EVENT = "Event",
  PROGRAM = "Program",
  SYSTEM_GENERATED_LIST = "System Generated List",
  FIELD = "Field",
  FIELD_OPTION = "Field Option",
  PURCHASE_ORDER = "Purchase Order",
  PROGRAM_ORGANIZATION = "Program Organization",
  PARTICIPANT_ROLE = "Participant Role",
  DISPLAY_NOTE = "Display Note",
  ACTIVITY = "Activity"
}

export enum AnalyticsContextEntityNameEnum {
  ATTENDEE = "Attendee",
  BULK_TICKET_ADMIN = "Bulk Ticket Admin",
  ORGANIZATION_ADMIN = "Organization Admin"
}
